module.exports = __webpack_public_path__ + "static/media/bagy16.a6bd237c.png";